import useJobContext from "../../useJobContext";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Tooltip, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: 0
        },
        daysInStageText: {
            marginLeft: theme.spacing(0.5),
            fontSize: 14
        },
        doNotHireIcon: {
            marginRight: theme.spacing(1)
        }
    })
);

interface IMainInfoProps {
    daysInStage: string;
    applicantLongTimeInStage: boolean;
    maxDaysInStage?: number;
    doNotHire?: boolean;
}

const JobKanbanApplicantMainInfo = (props: IMainInfoProps) => {
    const classes = useStyles();
    const [data] = useJobContext();

    const { t } = data;
    const [tApplicant] = data.tResponseListFilterKanban;

    const {
        daysInStage,
        applicantLongTimeInStage,
        maxDaysInStage,
        doNotHire
    } = props;
    const showMaxMessage =
        applicantLongTimeInStage && maxDaysInStage !== undefined;
    const displayText =
        maxDaysInStage === undefined
            ? t("KanbanCard_DaysInStage")
            : t("KanbanCard_DaysInStageMax", { max: maxDaysInStage });

    return (
        <Grid container className={classes.root}>
            <Grid container item>
                {doNotHire && (
                    <Tooltip
                        title={tApplicant("doNotHire") as string}
                        className={classes.doNotHireIcon}
                    >
                        <ThumbDownIcon color="error" fontSize="small" />
                    </Tooltip>
                )}
                <Tooltip title={displayText}>
                    <AccessTimeIcon
                        fontSize="small"
                        color={showMaxMessage ? "secondary" : undefined}
                    />
                </Tooltip>
                <Typography className={classes.daysInStageText}>
                    {daysInStage}d
                </Typography>
            </Grid>
            {/* {doNotHire && (
                <Grid container item>
                    <Tooltip title={t("KanbanCard_DoNotHire")}>
                        <BlockIcon color="error" fontSize="small" />
                    </Tooltip>
                </Grid>
            )} */}
        </Grid>
    );
};

export default JobKanbanApplicantMainInfo;
